<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>
        
        <div class="row">
            <div class="col-sm-12 form-group">
                <label for="ceder-sexo">Selecione o sexo</label>
                <select class="form-control" id="ceder-sexo" v-model="sexo" :disabled="dados.leitoSexo != 'I' ? true : false">
                    <option value="" selected disabled>Selecione</option>
                    <option value="I">Indiferente</option>
                    <option value="M">Masculino</option>
                    <option value="F">Feminino</option>
                </select>
                <small v-if="sexoInicial != 'I' & sexoEscolhido == ''" class="text-danger">campo obrigatório</small>
            </div>
        </div>

        <button type="button" class="btn btn-primary mt-2" @click.once="validaSessao('cederLeito')">Ceder o Leito</button>

    </div>
</template>

<script>
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    mixins: [
        validaSessao
    ],
    mounted () {
        this.sexo = this.dados.leitoSexo
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
    },
    watch: {
        'dados.leitoSexo' (value) {
            this.sexo = value
        }
    },
    data () {
        return {
            sexo: '',
        }
    },
    methods: {
        cederLeito () {
            let dados = {
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                sexo: this.sexo
            }
  
            this.$emit('ceder', dados)
        }
    }
}
</script>